import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import your translation files
import en from "./public/locales/en.json";
import tr from "./public/locales/tr.json";
import ar from "./public/locales/ar.json";

const resources = {
  en: {
    common: en,
  },
  tr: {
    common: tr,
  },
  ar: {
    common: ar,
  },
};

const i18nChain = i18n.use(initReactI18next);
// LanguageDetector reads navigator/localStorage/document.cookie — browser-only,
// must not run during Node.js SSR/build.
if (typeof window !== "undefined") {
  i18nChain.use(LanguageDetector);
}

i18nChain
  // Initialize i18next
  .init({
    resources,
    fallbackLng: "en",
    defaultNS: "common",
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
    detection: {
      // We explicitly don't want to use URL detection
      order: ["cookie", "localStorage", "navigator"],
      caches: ["localStorage", "cookie"],
    },
  });

export default i18n;

export const isRTL = i18n.dir() === "rtl";
